<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.otp"
      :ui-title="title"
      :ui-subtitle="subtitle"
    >
      <UiWrapper
        :name="FIELD_NAMES.OTPCode"
        :on-change="onChange"
        :validations="validations"
        :label="label"
        :blocker="isValidOTP"
      >
        <InputOtp
          type="tel"
          :resend-code="resendCode"
          resend-action="Resend code"
          resend-text=""
        />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>
import { InputOtp } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import FIELD_NAMES from '@/forms/constants/field-names';
import { OTP_VALIDATE } from '@/forms/constants/services';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

export default {
  name: 'FieldsetOtp',

  props: {
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a valid number',
          condition: conditions.isNumber,
          name: 'is-number',
        },
        {
          errorMessage: 'Oops! That is an incorrect code. Please try again.',
          condition: conditions.isValidServiceCondition(OTP_VALIDATE, FIELD_NAMES.OTPCode),
          name: 'opt-validation',
        },
      ]),
    },
    title: {
      type: String,
      default: 'Enter the code you received from us by SMS',
    },
    subtitle: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    resendCode: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    getErrorMessage() {
      return this.$children[0].model.errorMessages[this.FIELD_NAMES.OTPCode][0];
    },
  },

  mixins: [sharedComponentMixin],

  components: {
    InputOtp,
  },
};
</script>
